/** @format */

import React, { useState, useContext } from "react";
import {
  TextField,
  Grid,
  Button,
  Paper,
  Typography,
  makeStyles,
  CssBaseline,
  Breadcrumbs,
  Link,
  Box,
  Container,
} from "@material-ui/core";

//import InformeComercial from '/static/imagen/InformeComercialPlus1.png';
import swal from "sweetalert";
import Alert from "@material-ui/lab/Alert";
import Error from "../Error";
import Loading from "../modales/Loading";
import UserContext from "../../context/Globales/UserContext";

import { globales, mensajeglobales } from "../../helpers/Confi";
import { isMobile } from "react-device-detect";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(5, 1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "90%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
}));

const Soporte = () => {
  const history = useHistory();

  const parametros = globales(); //  parametros globales:
  const MSG = mensajeglobales(); // mensaje globales;

  const [OpenLoading, setOpenLoading] = useState(false);

  const [error, setError] = useState(false);
  const [StateMensaje, setStateMensaje] = useState(false);
  //const {  DataLogin } = useContext(UserContext);

  const userContext = useContext(UserContext);
  const [errorText, setErrorText] = useState();
  const expreg = new RegExp("[a-zA-Z0-9]+"); // letras y numeros
  const expregMail = /\w+@\w+\.+[a-z]/; // expresion que evalua el email

  const classes = useStyles();

  // estado busqueda del formulario
  const [soporte, setSoporte] = useState({
    email: "",
    asunto: "",
    descripcion: "",
  });

  const { email, asunto, descripcion } = soporte;

  const ocultarMensaje = () => {
    setSoporte({
      email: "",
      asunto: "",
      description: "",
    });
    setStateMensaje(false);
  };

  const handleChange = (e) => {
    setSoporte({
      ...soporte,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (localStorage.getItem("autenticado")) {
      setOpenLoading(true);

      //validacion
      if (
        email.trim() === "" ||
        !expregMail.test(email) ||
        asunto.trim() === "" ||
        !expreg.test(asunto) ||
        descripcion.trim() === "" ||
        !expreg.test(descripcion)
      ) {
        setTimeout(() => {
          setError(true);
          setOpenLoading(false);
        }, 1500);
        //limpiar campos
        e.target.reset();
      } else {
        // EJECUCION API DE SOPORTE
        userContext.Soporte(soporte);
        // console.log('va a consultar')

        setTimeout(() => {
          setError(false);
          setOpenLoading(false);

          //limpiar campos
          swal({
            title: "Excelente",
            text: MSG.MSG_ENVIADO_CON_EXITO,
            icon: "success",
            button: "ok",
          });
          setSoporte({
            email: "",
            asunto: "",
            description: "",
          });
          setTimeout(() => {
            // window.location.href = "soporte";
            setStateMensaje(true);
          }, 1000);
        }, 2000);
      }
    } else {
      swal({
        title: "Atención",
        text: MSG.MSG_ERROR_AUTORITETIONS_401,
        icon: "warning",
        button: "OK",
      });
    }
  };

  const AlertMensaje = (
    <>
      <Alert
        variant="filled"
        severity="success"
        action={
          <Button color="inherit" size="small" onClick={ocultarMensaje}>
            ACEPTAR
          </Button>
        }
      >
        Su mensaje ha sido enviado con éxito, <b>Contacto - Soporte</b>
      </Alert>
    </>
  );

  return (
    <>
      <div style={{ width: "100%" }}>
        <br />
        {OpenLoading ? <Loading /> : null}

        <br />

        <Box display="flex" justifyContent="center">
          {StateMensaje ? (
            <>
              <br />
              <div
                style={{
                  textAlign: "center",
                  alignContent: "center",
                  padding: "80px",
                  width: "100%",
                }}
              >
                {AlertMensaje}
              </div>{" "}
            </>
          ) : (
            <Container maxWidth="sm" component={Paper} elevation={5}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                direction="column"
                justify="center"
                alignItems="center"
              >
                {isMobile ? (
                  <>
                    <br />
                    <br />
                    <br />
                    <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => history.push("MenuMobile")}
                        style={{ alignItems: "center", paddingTop: "5px" }}
                      >
                        Menú Principal
                      </Button>
                    </Grid>
                  </>
                ) : (
                  ""
                )}
                <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                  <Typography
                    component="h1"
                    variant="h4"
                    style={{ textAlign: "center", paddingTop: "5px" }}
                    className={classes.paper}
                  >
                    {" "}
                    {/*el component es para quelo tome como un h1 */}
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/static/imagen/InfoSoporte.png"
                      }
                      style={{ width: "100px", height: "100px" }}
                      alt="Logo Informe"
                      title="logo informe"
                    />
                    Contacto Soporte
                  </Typography>
                </Grid>

                <Grid
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  xl={12}
                  lg={12}
                  justify="center"
                  alignItems="center"
                >
                  <form
                    className={classes.form}
                    onSubmit={handleSubmit}
                    autoComplete="off"
                  >
                    {error ? (
                      <Error mensaje="Debe Completar todos los campos " />
                    ) : null}

                    <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
                      <TextField
                        error={errorText ? errorText : ""}
                        floatingLabelText="email"
                        type="email"
                        label="Email"
                        id="outlined-error-helper-text"
                        margin="normal"
                        fullWidth
                        name="email"
                        value={email}
                        onChange={handleChange}
                        variant="outlined"
                        autoFocus
                        required
                      />

                      <TextField
                        type="text"
                        id="asunto"
                        label="Asunto"
                        margin="normal"
                        fullWidth
                        name="asunto"
                        value={asunto}
                        onChange={handleChange}
                        variant="outlined"
                        required
                      />

                      <TextField
                        type="text"
                        label="Mensaje"
                        id="descripcion"
                        name="descripcion"
                        value={descripcion}
                        onChange={handleChange}
                        margin="normal"
                        fullWidth
                        multiline
                        rows={6}
                        placeholder="Indique mensaje (max. 1000)"
                        variant="outlined"
                        required
                      />
                    </Grid>
                    <Box my={2}>
                      <Button
                        color="secondary"
                        disabled={
                          asunto.length > 0 &&
                          email.length > 0 &&
                          descripcion.length > 0
                            ? false
                            : true
                        }
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                      >
                        {OpenLoading ? "Enviando información..." : "Enviar"}
                      </Button>
                    </Box>
                  </form>
                </Grid>
              </Grid>
            </Container>
          )}
        </Box>
      </div>
    </>
  );
};
export default Soporte;
